import { type ApartmentTerms } from '@pigello/pigello-matrix';
import type { RelationFieldProps } from './types';
import { sendOutFilters } from '@/app/settings/modules/communication/send-out-templates/filters';

export const ApartmentTermsItem: RelationFieldProps<ApartmentTerms> = {
  filters: sendOutFilters,
  renderItem: (item) => ({
    title: item.name,
    descriptionItems: <></>,
  }),
};
